import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileTextIcon, ScaleIcon, ShieldIcon } from 'lucide-react';
export function TermsOfUse() {
  const lastUpdated = 'September 15, 2023';
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2681" data-mp="31kbc2fp32l2v">
      <Header data-id="element-2682" data-mp="36iuwgbo13ot4" />
      <main className="flex-grow" data-id="element-2683" data-mp="36ict6v2y8abp">
        {/* Hero Section */}
        <section className="bg-navy-800 text-white py-12" data-id="element-2684" data-mp="2ssj369fpjk0e">
          <div className="container mx-auto px-4" data-id="element-2685" data-mp="2sqy6ad5x7ozd">
            <div className="max-w-3xl mx-auto text-center" data-id="element-2686" data-mp="2xj7vfqz7ol0l">
              <h1 className="text-4xl font-bold mb-4" data-id="element-2687" data-mp="2xksr5jx9ia01">Terms of Use</h1>
              <p className="text-lg mb-2" data-id="element-2688" data-mp="2ivmv24tq0zwd">
                Guidelines for using the CalMiR website and services
              </p>
              <p className="text-sm text-gray-300" data-id="element-2689" data-mp="2nqtomjta0o7k">
                Last Updated: {lastUpdated}
              </p>
            </div>
          </div>
        </section>
        {/* Terms of Use Content */}
        <section className="py-12" data-id="element-2690" data-mp="2dwtdo1bbcoqx">
          <div className="container mx-auto px-4" data-id="element-2691" data-mp="2k4usvlvb7nkb">
            <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-2692" data-mp="2k7qp95rie46n">
              <div className="p-8" data-id="element-2693" data-mp="2f8nk7lbj3xyo">
                <div className="prose max-w-none" data-id="element-2694" data-mp="2u4dcu2b7z9cd">
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2695" data-mp="2u327hy24ltj5">
                    Introduction
                  </h2>
                  <p className="mb-6" data-id="element-2696" data-mp="21f63e8a88zcc">
                    Welcome to the California Institute for Microbiome Research
                    ("CalMiR"). These Terms of Use govern your access to and use
                    of our website, research materials, and services. By
                    accessing or using our website, you agree to be bound by
                    these Terms of Use and our Privacy Policy.
                  </p>
                  <p className="mb-6" data-id="element-2697" data-mp="1inn000cajj9s">
                    Please read these Terms of Use carefully before using our
                    website. If you do not agree with any part of these terms,
                    you may not access or use our website or services.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2698" data-mp="27ej81ctclhbj">
                    Acceptable Use
                  </h2>
                  <p className="mb-4" data-id="element-2699" data-mp="2c6kt9o8huidp">
                    When using our website and services, you agree to:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-2700" data-mp="2h6you6swrzuu">
                    <li className="mb-2" data-id="element-2701" data-mp="1kg6iw1zovo6s">
                      Use our website and services only for lawful purposes and
                      in accordance with these Terms
                    </li>
                    <li className="mb-2" data-id="element-2702" data-mp="1tes09ttfcx5z">
                      Not use our website in any way that violates applicable
                      laws or regulations
                    </li>
                    <li className="mb-2" data-id="element-2703" data-mp="34tnc780oskiu">
                      Not attempt to gain unauthorized access to any part of our
                      website, server, or database
                    </li>
                    <li className="mb-2" data-id="element-2704" data-mp="y5ekxmk9cmmr">
                      Not interfere with or disrupt the integrity or performance
                      of our website or services
                    </li>
                    <li className="mb-2" data-id="element-2705" data-mp="oflaiovuqdk3">
                      Not engage in any conduct that restricts or inhibits
                      anyone's use or enjoyment of our website
                    </li>
                  </ul>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2706" data-mp="fhjbufzlbwzz">
                    Intellectual Property Rights
                  </h2>
                  <p className="mb-6" data-id="element-2707" data-mp="5hiq6ne914sm">
                    The content, features, and functionality of our website,
                    including but not limited to text, graphics, logos, images,
                    videos, and software, are owned by CalMiR or our licensors
                    and are protected by United States and international
                    copyright, trademark, patent, and other intellectual
                    property laws.
                  </p>
                  <p className="mb-6" data-id="element-2708" data-mp="22vk5h1kvp30e">
                    You may access, view, and use our content for your personal,
                    non-commercial use. You may not reproduce, distribute,
                    modify, create derivative works of, publicly display,
                    publicly perform, republish, download, store, or transmit
                    any of our content without our express written permission.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2709" data-mp="1oyotp1d8sxgn">
                    Research and Educational Content
                  </h2>
                  <p className="mb-6" data-id="element-2710" data-mp="1a6wdkn5mjfdv">
                    Our website provides information about microbiome research,
                    educational resources, and scientific findings. This content
                    is provided for informational and educational purposes only
                    and should not be considered medical advice, diagnosis, or
                    treatment recommendations.
                  </p>
                  <p className="mb-6" data-id="element-2711" data-mp="hmsnhd9duodx">
                    We strive to ensure the accuracy and reliability of our
                    content, but we make no representations or warranties about
                    the completeness, reliability, or accuracy of this
                    information. Any reliance you place on such information is
                    strictly at your own risk.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2712" data-mp="10lwted5mo21d">
                    User Contributions
                  </h2>
                  <p className="mb-6" data-id="element-2713" data-mp="1ebqhuud80kak">
                    If you submit, post, or share any content on our website
                    (such as comments, feedback, or research participation), you
                    grant CalMiR a non-exclusive, royalty-free, perpetual,
                    irrevocable, and fully sublicensable right to use,
                    reproduce, modify, adapt, publish, translate, create
                    derivative works from, distribute, and display such content
                    throughout the world in any media.
                  </p>
                  <p className="mb-6" data-id="element-2714" data-mp="pxtxiwhry9c8">
                    You represent and warrant that you own or control all rights
                    to the content you submit, that the content is accurate, and
                    that your submission does not violate these Terms of Use or
                    any applicable law.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2715" data-mp="14pm3ihvoib1a">
                    Disclaimers
                  </h2>
                  <p className="mb-6" data-id="element-2716" data-mp="1do7lobx8no1j">
                    YOUR USE OF OUR WEBSITE AND SERVICES IS AT YOUR SOLE RISK.
                    OUR WEBSITE AND SERVICES ARE PROVIDED ON AN "AS IS" AND "AS
                    AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
                    EXPRESS OR IMPLIED.
                  </p>
                  <p className="mb-6" data-id="element-2717" data-mp="37xw6ahu8wnz0">
                    CALMIR DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
                    INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                    NON-INFRINGEMENT, AND TITLE.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2718" data-mp="2t5c9s01lpeqj">
                    Limitation of Liability
                  </h2>
                  <p className="mb-6" data-id="element-2719" data-mp="3lvt5lm0338hd">
                    IN NO EVENT SHALL CALMIR, ITS OFFICERS, DIRECTORS,
                    EMPLOYEES, AGENTS, OR AFFILIATES BE LIABLE FOR ANY INDIRECT,
                    INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
                    INCLUDING BUT NOT LIMITED TO, LOSS OF PROFITS, DATA, USE,
                    GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR
                    ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE OUR
                    WEBSITE OR SERVICES.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2720" data-mp="4hy40op0916l">
                    Governing Law
                  </h2>
                  <p className="mb-6" data-id="element-2721" data-mp="3rkugh5s0gd8v">
                    These Terms of Use and your use of our website and services
                    shall be governed by and construed in accordance with the
                    laws of the State of California, without regard to its
                    conflict of law provisions. Any legal action or proceeding
                    relating to your access to or use of our website or services
                    shall be instituted in the federal or state courts located
                    in San Francisco County, California.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2722" data-mp="172q6vsh0334r">
                    Changes to These Terms
                  </h2>
                  <p className="mb-6" data-id="element-2723" data-mp="1btygopm8sqig">
                    We may revise these Terms of Use from time to time. The most
                    current version will always be posted on our website with
                    the effective date. Your continued use of our website after
                    any changes to these Terms of Use constitutes your
                    acceptance of such changes.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-2724" data-mp="1pzgwy35dkppt">
                    Contact Us
                  </h2>
                  <p className="mb-6" data-id="element-2725" data-mp="y7ixq1wumc5i">
                    If you have any questions about these Terms of Use, please
                    contact us at:
                  </p>
                  <div className="bg-gray-50 p-4 rounded mb-6" data-id="element-2726" data-mp="1c8limbc3xgeu">
                    <p className="mb-2" data-id="element-2727" data-mp="1775yclhr7dxi">
                      <strong data-id="element-2728" data-mp="17aad2csuhs2f">
                        California Institute for Microbiome Research
                      </strong>
                    </p>
                    <p className="mb-2" data-id="element-2729" data-mp="2imb4y0l09wme">123 Science Way</p>
                    <p className="mb-2" data-id="element-2730" data-mp="cd91z30l1oon">San Francisco, CA 94107</p>
                    <p className="mb-2" data-id="element-2731" data-mp="cch5zr32poxu">Email: legal@calmir.org</p>
                    <p data-id="element-2732" data-mp="7dw7px7dtfc1">Phone: (415) 555-0123</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-2733" data-mp="3tu0d59jgpvbm" />
    </div>;
}